import { render } from "./SwAbout.vue?vue&type=template&id=34d99a50&scoped=true"
const script = {}

import "./SwAbout.vue?vue&type=style&index=0&id=34d99a50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34d99a50"

export default script